import { render, staticRenderFns } from "./DemoAccountAllTabs.vue?vue&type=template&id=1a838301"
import script from "./DemoAccountAllTabs.vue?vue&type=script&lang=js"
export * from "./DemoAccountAllTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports